// The approved booking-slug grammar, shared by the router and anything that
// needs to know whether a root segment could possibly be a professional.
//
// Copied from the redirect rule in firebase.json, which is the authoritative
// version because lura.link matches on it in production:
//
//   ^/(?P<slug>[a-z0-9][a-z0-9-]{1,58}[a-z0-9])$
//
// Lowercase a-z0-9 and hyphens, 3-60 characters, no leading or trailing
// hyphen, no dots and no slashes. The backend enforces the same floor, which
// is why `/a` is safe to claim as a namespace.
const SLUG = /^[a-z0-9][a-z0-9-]{1,58}[a-z0-9]$/;

/**
 * Could this root segment be a professional's booking slug?
 *
 * This is a SHAPE check, not an existence check — whether the professional
 * exists is the resolver's answer, and the two must not be conflated. A string
 * that fails here can never have been issued, so it is not worth a round trip
 * and must not be echoed back to the visitor.
 */
export function isPossibleSlug(value: string | undefined): value is string {
  return typeof value === "string" && SLUG.test(value);
}
